import React, { ReactNode } from "react";

import { useIntl } from "react-intl";

import { ActivityTypeRef } from "@mapmycustomers/shared/types/entity/activities/ActivityType";
import { FormItem } from "@mapmycustomers/ui";
import { SelectField } from "@mapmycustomers/ui";

import ActivityTypeIcon from "@app/component/activity/ActivityTypeIcon";

import messages from "./messages";

interface LockedActivityTypeProps {
  activityType: ActivityTypeRef;
  isAutoEmail?: boolean;
  lockTooltip?: ReactNode;
}

const LockedActivityType = ({
  activityType,
  isAutoEmail,
  lockTooltip,
}: LockedActivityTypeProps) => {
  const intl = useIntl();

  return (
    <>
      <SelectField
        disabled
        locked
        lockTooltip={lockTooltip ?? intl.formatMessage(messages.activityTypeLockTooltip)}
        placeholder={
          isAutoEmail ? intl.formatMessage(messages.activityTypeAutoEmailName) : activityType.name
        }
        prefixIcon={
          <ActivityTypeIcon activityType={activityType} isAutoEmail={isAutoEmail} size="sm" />
        }
      />
      <FormItem hidden name="activityTypeId" />
    </>
  );
};

export default LockedActivityType;
